import angular from 'angular';
import delegatedCardAvatarComponent from './delegatedCardAvatar.component';

let delegatedCardAvatarModule = angular.module('delegatedCardAvatar', [])

.component('delegatedCardAvatar', delegatedCardAvatarComponent)

.name;

export default delegatedCardAvatarModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardRow/homeDelegatedCard/delegatedCardAvatar/delegatedCardAvatar.js